import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { LinkButton } from '../../button/LinkButton';

const FooterSC = styled.footer`
  border-top: 1px solid ${(props) => props.theme.colors.shadows.slateGray[10]};
  color: ${(props) => props.theme.colors.oxfordBlue[50]};
  text-align: center;
  font-size: 0.875rem;
  line-height: ${(props) => props.theme.lineHeights.xxs};
  font-weight: 500;
  padding: 1rem;

  p {
    margin: 0;
    line-height: 1.25rem;
  }

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    padding-block: 1.875rem;
  }
`;

const SpanSC = styled.span`
  display: block;
  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    display: inline;
  }
`;

const BoldSC = styled.span`
  font-weight: 600;
`;

type DemoFooterProps = {
  allRightsReservedText?: string;
  children?: React.ReactNode;
  className?: string;
  'data-test-id'?: string;
  linkLabel: string;
  loading?: boolean;
  onLabelClick?: () => void;
  privacyPolicyText: string;
  versions: {
    app?: string;
    dis?: string;
    iFace?: string;
    sam?: string;
    webComponents?: string;
  };
};

export const DemoFooter = ({
  allRightsReservedText,
  children,
  linkLabel,
  loading,
  onLabelClick,
  privacyPolicyText,
  versions,
  ...props
}: DemoFooterProps) => {
  const date = new Date();
  const { app, dis, iFace, sam, webComponents } = versions;

  const getAppInfo = () => {
    if (loading) {
      return <span>&nbsp;</span>;
    }

    return (
      <SpanSC>
        (<BoldSC>Demo: </BoldSC> v{app}, <BoldSC>Web components:</BoldSC> v{webComponents},<BoldSC> DIS:</BoldSC> v{dis}
        ,<BoldSC> iFace:</BoldSC> v{iFace},<BoldSC> SAM:</BoldSC> v{sam})
      </SpanSC>
    );
  };

  return (
    <FooterSC {...props}>
      {children}
      <p>
        &copy; {date.getFullYear()} Innovatrics. {allRightsReservedText ?? 'All rights reserved'}.&nbsp;
        <br />
        <motion.span animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ duration: 0.25 }}>
          {getAppInfo()}
        </motion.span>
      </p>
      <p>
        {privacyPolicyText} <LinkButton onClick={onLabelClick}>{linkLabel}</LinkButton>.
      </p>
    </FooterSC>
  );
};
